"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.participantDocument = void 0;
var types_1 = require("../../../types");
exports.participantDocument = {
    dateCreated: "2021-07-26T19:09:11Z",
    form: {
        actions: [],
        allowedDocumentEditor: "DOCUMENT_CREATOR",
        defenses: [],
        displayConditions: [],
        id: 1199601,
        isRehuddleEligible: true,
        lastModifiedDate: "2021-07-23T14:01:39.441612Z",
        name: "Some Participant Questions",
        rootId: 1176152,
        sections: [
            {
                id: 1199851,
                items: [
                    {
                        answerSource: {
                            dataSourceKey: "PARTICIPANT",
                            id: 1200051,
                            isFromWidget: null,
                            properties: {
                                answerField: "fullName",
                                autoComplete: false,
                                detailedSearch: {
                                    title: "Add Participant",
                                    enabled: true,
                                    linkName: "Add Participant",
                                    searchBy: "Search by name or member ID",
                                    subtitle: "Who would you like to add?",
                                    infiniteListTitle: "Participants by Alphabetical Order",
                                    infiniteListSortBy: "fullName",
                                    recentAnswersTitle: "Recently Added Participants",
                                    customAnswerEnabled: true,
                                    infiniteListEnabled: true,
                                    recentAnswersEnabled: true,
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        hasDefenses: false,
                        id: 1200001,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-07-23T14:01:39.032987Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: "SUPERVISOR",
                        properties: {
                            placeHolderText: "Supervisor Placeholder",
                        },
                        rootId: 1175952,
                        selections: [],
                        subType: "PARTICIPANT",
                        tags: [],
                        title: "The Supervisor",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "PARTICIPANT",
                            id: 1200201,
                            isFromWidget: null,
                            properties: {
                                answerField: "fullName",
                                autoComplete: false,
                                detailedSearch: {
                                    title: "Add Participant",
                                    enabled: true,
                                    linkName: "Add Participant",
                                    searchBy: "Search by name or member ID",
                                    subtitle: "Who would you like to add?",
                                    infiniteListTitle: "Participants by Alphabetical Order",
                                    infiniteListSortBy: "fullName",
                                    recentAnswersTitle: "Recently Added Participants",
                                    customAnswerEnabled: true,
                                    infiniteListEnabled: true,
                                    recentAnswersEnabled: true,
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        hasDefenses: false,
                        id: 1200151,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-07-23T14:01:39.058186Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: "ATTENDANT",
                        properties: {
                            allowMultipleAnswers: true,
                            placeHolderText: "Attendant Placeholder",
                        },
                        rootId: 1200151,
                        selections: [],
                        subType: "PARTICIPANT",
                        tags: [],
                        title: "The Participants",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        allowedTypes: [types_1.SignatureType.DRAWN, types_1.SignatureType.TYPED_EMAIL],
                        id: 1199951,
                        questions: [],
                        rootId: 1176352,
                        signatureRequired: false,
                        subType: "SIGNATURE",
                        type: "WIDGET",
                    },
                ],
                parentWidgetRootId: null,
                properties: null,
                rootId: 1175502,
                title: null,
                workflowType: "FINAL",
            },
        ],
        sharingEnabled: true,
        signatureRequired: false,
        startFromWorkOrderEnabled: true,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    formActionRequests: [],
    formSummary: {
        id: 1195001,
        name: "Some Participant Questions",
        rootId: 1195001,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    id: 1201151,
    operationalExperiences: [],
    owner: {
        fullName: 'Riley, Todd "The Toddster"',
        name: "Todd Riley",
        participantId: 1062251,
    },
    participants: [],
    photos: [],
    readOnly: false,
    responses: [],
    resubmissions: [],
    sectionComments: [],
    startDate: "2021-07-26T19:09:11Z",
    status: types_1.DocumentStatus.NEW,
    submissionDate: "2021-07-26T19:09:11Z",
    submissionId: 1201201,
    submissionType: types_1.DocumentSubmissionType.NEW,
    summary: {},
    title: "New Document",
};
//# sourceMappingURL=participantDocument.js.map